export default "__VITE_ASSET__d4a89695__"